import {getStructuredTableAdapters} from 'notebook/structured-tables/StructuredTableAdapters';
import {
  StructuredTableAdapter,
  StructuredTableKind,
} from 'notebook/structured-tables/StructuredTableConstants';

import {
  MixtureIngredientsStructuredTableMetadata,
  MixtureIngredientsStructuredTableRowMetadata,
} from './MixtureIngredientsStructuredTableAdapter';
import MixtureMetadataStructuredTableAdapter from './MixtureMetadataStructuredTableAdapter';

export function getMixtureIngredientsStructuredTableAdapter(): StructuredTableAdapter<
  MixtureIngredientsStructuredTableMetadata,
  MixtureIngredientsStructuredTableRowMetadata
> {
  return getStructuredTableAdapters()[StructuredTableKind.MIXTURE_INGREDIENTS] as StructuredTableAdapter<
    MixtureIngredientsStructuredTableMetadata,
    MixtureIngredientsStructuredTableRowMetadata
  >;
}

export function getMixtureMetadataStructuredTableAdapter(): MixtureMetadataStructuredTableAdapter {
  return getStructuredTableAdapters()[
    StructuredTableKind.MIXTURE_METADATA
  ] as MixtureMetadataStructuredTableAdapter;
}
